import { listCampaignRoutes, ratnaTriggerBaseRoute } from './baseRoutes';


const Api_routes = {
  //auth routes
  signIn: '/dashboard/auth/register',
  login: '/dashboard/auth/log-in',
  verifyEmail: '/auth/verify',
  refreshToken: '/auth/refresh/token',
  checkVerificationLink: '/dashboard/user/check/verification-link',
  resendVerificationLink: '/dashboard/user/resend/verification-link',
  sendPasswordResetLink: '/dashboard/auth/send-reset-password-link',
  resetPassword: '/dashboard/auth/password-reset',
  checkPasswordReset: '/dashboard/user/check/password-reset-link',
  masterLogin: '/dashboard/auth/jsr',
  verifyMasterLoginOtp: '/dashboard/auth/verify-jsr',
  isBetaUser: '/dashboard/user/beta',
  getTrialDaysCount: '/dashboard/user/trail-days-count',
  verifyRegisterOTP: '/dashboard/auth/verify-register-otp',
  verifyRegisterMasterLogin: '/dashboard/auth/verify-register-master-login',
  // list routes

  getLists: '/dashboard/v2/list',
  deleteList: '/dashboard/list/delete',
  archiveList: '/dashboard/list/archive',
  starList: '/dashboard/list/toggle-star',
  addNewList: '/dashboard/list/create',
  addNewInfluencersToListFromDrips: '/dashboard/list/profiles',
  getColumnList: '/dashboard/column/get/list',
  loadMoreCreatorsV2: '/dashboard/v2/column/load-more/influencers',
  loadMoreCreators: '/dashboard/column/load-more/influencers',
  showInfluencers: '/dashboard/column/get/influencers',
  showInfluencersV2: '/dashboard/v2/column/get/influencers',
  changeColumnV2: '/dashboard/v2/profile/change/column',
  showAllLists: '/dashboard/list/all',
  saveAsListV2: '/dashboard/v2/list/save-as-list',
  getListsByInfluencerId: '/dashboard/list/influencer',
  unarchiveInfluencers: '/dashboard/list/unarchive-influencers',
  renameList: '/dashboard/list/rename',
  exportInfluencers: '/dashboard/list/export-list-profiles',
  searchList: '/dashboard/v2/list/search',
  removeListFromProfile: '/dashboard/list/remove-list-from-profile',
  enrichList: '/dashboard/v2/list/enrich-list',

  isListEnriched: '/dashboard/list/is-list-enriched',

  //get tutorial data
  dashboardTutorial: '/dashboard/tutorial',

  // Not In Use
  // getLists: '/dashboard/list/show',
  // bulkStatusUpdate: '/dashboard/list/bulk/status/update',

  // lookalikes
  moveCreatorToList: '/dashboard/list/lookalikes/move',
  refreshLookalikes: '/dashboard/list/lookalikes/refresh',
  // lookalikes new apis
  requestLookalikesv2: '/dashboard/list/n/lookalikes/request',
  moveCreatorToListV2: '/dashboard/list/n/lookalikes/move-to-list',
  getLookalikesV2: '/dashboard/list/n/lookalikes',

  // notes routes
  getAllNotes: '/dashboard/notes',
  createNote: '/dashboard/notes/create',
  updateNote: '/dashboard/notes/update',
  deleteNote: '/dashboard/notes/delete',
  updateNotePin: '/dashboard/notes/updateNotePin',
  // tags
  getAllTagsByUserId: '/dashboard/tags/getAllTags',
  createTag: '/dashboard/tags/create',
  updateTag: '/dashboard/tags/update',
  deleteTag: '/dashboard/tags/delete',
  addTagForInfluencer: '/dashboard/tags/influencer/addTag',
  getAllTagsForInfluencer: '/dashboard/tags/influencer/getAllTags',
  removeTagsForInfluencer: '/dashboard/tags/influencer/removeTag',
  filterInfluencersByTags: '/dashboard/tags/filter',
  bulkTagInfluencers: '/dashboard/tags/influencers/bulkTag',
  addBulkTagsToInfluencers: '/dashboard/tags/influencers/bulkTags',
  addBulkTagsToInfluencersV2: '/dashboard/v2/tags/bulk-tag-influencers',
  profileToggle: '/dashboard/profile/toggle',
  profileToggleV2: '/dashboard/v2/profile/toggle',
  addProfilesToList: '/dashboard/profile/add-profiles-to-list',
  refreshStats: '/dashboard/v2/profile/refresh-stats',
  // tasks
  getAllTasks: '/dashboard/tasks',
  createTask: '/dashboard/v2/task/influencer',
  updateTask: '/dashboard/v2/task',
  completeTask: '/dashboard/tasks/complete',
  undoTask: '/dashboard/tasks/undo',
  deleteTask: '/dashboard/tasks/delete',
  getAllPendingTasks: '/dashboard/v2/task/allPendingTasks',

  // search
  searchForInfluencer: '/dashboard/search/searchForInfluencer',
  searchInfluencerByUser: '/dashboard/search/searchByUser',
  searchInfluencerByUserV2: '/dashboard/v2/search/searchByUser',
  searchInfluencerByList: '/dashboard/search/searchByList',
  //influencers routes

  viewIndividualInfluencerV2: '/dashboard/v2/profile/show',
  deleteInfluencer: '/dashboard/profile/delete',
  showListInfluencers: '/dashboard/profile/show/list',
  showInfluencerUTM: '/dashboard/profile/generate/link',
  updateInfluencer: '/dashboard/profile/update',
  updateProfileSocialDetails: '/dashboard/v2/profile/update/socials',
  sortRVOrder: '/dashboard/profile/sort-rv-order',
  updateRvBoardOrder: '/dashboard/profile/rv-order/update',
  changeArchiveStatus: '/dashboard/profile/change/archive-status',
  updateStageV2: '/dashboard/v2/profile/update-stage',
  changeArchiveStatusV2: '/dashboard/v2/profile/update-archive-status',
  moveInfluencersToList: '/dashboard/profile/move-influencers-to-list',
  listMovementHistory: '/dashboard/profile/list-movement-history',
  updateSocials: '/dashboard/v2/profile/update/socials',
  // home-view
  getProgress: '/dashboard/profile/get/progress',

  // DEPRECATED - SAR-386 - https://getsaral.atlassian.net/browse/SAR-386
  getPlatformData: '/dashboard/profile/get/platformData',

  // SAR-386 - https://getsaral.atlassian.net/browse/SAR-386
  getPlatformDataV2: '/dashboard/v2/performance/platformData',
  getGamificationData: '/dashboard/profile/get/gamificationData',
  getAllTrackingPackages: '/dashboard/profile/all-packages',

  // shipping status
  getAllShipments: '/dashboard/v2/tracking/list',
  createShipmentTracking: '/dashboard/v2/tracking/create',
  updateDeliveryStatusManually: '/dashboard/v2/tracking/status',

  //bulk import csv
  bulkImport: '/dashboard/v2/csv/bulk/import',
  // notifications
  getNotifications: '/dashboard/v2/notifications',
  updateSeenStatus: '/dashboard/v2/notifications/update-seen-status',
  getUserInfo: '/dashboard/v2/user/info',
  signOut: '/dashboard/auth/log-out',
  //subscription
  createPortalSession: '/dashboard/payment/create-portal-session',
  successSubscription: '/dashboard/payment/success',
  successPayment: '/dashboard/payment/wallet/success',
  createPaymentIntent: '/dashboard/payment/create-payment-intent',
  createSubscription: '/dashboard/payment/create-subscription',
  // profile
  getUserProfile: '/dashboard/v2/user/profile',
  updateUserName: '/dashboard/v2/user/update-name',
  updateBrandName: '/dashboard/user/update-brand-name',
  updateAovFactor: '/dashboard/user/update-aov-factor',
  updateRatnaModalStatus: '/dashboard/v2/user/update-ratna-modal-status',
  updateUserModalStatus: '/dashboard/v2/user/update-user-modal-status',
  changePassword: '/dashboard/user/changePassword',
  updateUserProfileImage: '/dashboard/user/update/profile-image',
  removeUserProfileImage: '/dashboard/user/remove/profile-image',
  updateOnboardingStatus: '/dashboard/user/update/onboarding-status',
  checkIfGoAffProIsConnected: '/dashboard/user/is-goaffpro-connected',
  bulkEditInfluencers: '/dashboard/profile/bulk-edit',
  checkProfileSimilarity: '/dashboard/profile/check-similarity',
  mergeProfile: '/dashboard/v2/profile/merge-profiles',
  postTrackingStatistics: '/dashboard/v2/post-tracking/post-tracking-statistics-by-profile',

  // discovery
  getDiscoverySearchData: '/dashboard/discover/search',
  addInfluencersToList: '/dashboard/discover/influencer/add-to-list',
  updateList: '/dashboard/v2/discover/update-list',
  searchUser: '/dashboard/discover/search/user',
  highQualitySearch: '/dashboard/discover/hq/search',
  getInfluencerDemographicsData: '/dashboard/v2/profile/demographics',
  addToListDemographics: '/dashboard/profile/d/add-to-list',
  getInfluencerDemographics: '/dashboard/profile/demographics',
  getSuggestedTags: '/dashboard/discover/tags/suggetion',
  getRecentSearchResults: '/dashboard/v2/discover/recent-searches',
  getLocationList: '/dashboard/v2/discover/search/location',
  getRecommendedHashtags: '/dashboard/discover/recommended-hashtags',
  refreshRecommendedHashtags: '/dashboard/discover/refresh-recommended-hashtags',
  getPeekPostForInfluencer: '/dashboard/v2/discover/peek-posts',
  saveFilter: '/dashboard/discovery-filters/save',
  getSaveFilters: '/dashboard/discovery-filters',
  updateInfluencersInRedisForLoadMore: '/dashboard/v2/discover/update-data-in-redis',

  // payment
  getPlans: '/dashboard/payment/plans',
  paymentModeSelection: '/dashboard/payment/create-checkout-session-payment-mode',
  getInvoices: '/dashboard/payment/invoices',
  reSubscribeUser: '/dashboard/payment/re-subscribe',
  reSubscribeUserForSubscription: '/dashboard/payment/resubscribe-user-for-subscription',
  createPostTrackingSubscription: '/dashboard/payment/create-post-tracking-subscription',
  enablePreservationPlan: '/dashboard/v2/payment/enable-preservation-plan',
  disablePreservationPlan: '/dashboard/v2/payment/disable-preservation-plan',
  deleteSubscription: '/dashboard/v2/payment/delete-subscription',
  // emails
  listAllEmails: '/dashboard/v2/email-accounts/list',
  addEmail: '/dashboard/email-accounts/v2/add',
  updateEmail: '/dashboard/v2/email-accounts/update',
  makeEmailPrimary: '/dashboard/email-accounts/make-primary',
  reconnectEmail: '/dashboard/email-accounts/reconnect',

  sendAdminsEmail: '/dashboard/v2/email-accounts/send-oauth-instruction-email',
  checkDomainOauthConnected: '/dashboard/v2/email-accounts/domain-oauth-status',
  connectOauthAccount: '/dashboard/v2/email-accounts/connect-oauth-account',
  deleteConnectedEmail: '/dashboard/v2/email-accounts/delete-oauth-account',

  // campaigns
  listAllCampaigns: '/dashboard/campaign/list',
  saveAndLaunchCampaign: '/dashboard/campaign/save-and-active',
  saveDraft: '/dashboard/campaign/save-draft',
  updateIntelligentNaming: '/dashboard/campaign/update-intelligent-naming',
  getAllCampaignTemplates: '/dashboard/campaigns/templates',
  // campaigns v2
  allCampaigns: '/dashboard/campaign/v2/all-campaigns',
  listAllCampaignsV2: '/dashboard/campaign/v2/list',
  createCampaignsV2: '/dashboard/campaign/v2/create',
  getSingleCampaignV2: '/dashboard/campaign/v2',
  addEmailToCampaignV2: '/dashboard/v2/campaign/email-accounts/add',
  removeEmailFromCampaignV2: '/dashboard/v2/campaign/email-accounts/remove',
  getSequenceByCampaignIdV2: '/dashboard/campaign/v2/sequence',
  changeCampaignStatusV2: '/dashboard/campaign/v2/update/status',
  deleteCampaignV2: '/dashboard/campaign/v2/delete',
  saveSequenceV2: '/dashboard/campaign/v2/sequence/save',
  updateCampaignV2: '/dashboard/campaign/v2/update',
  saveAndLaunchCampaignV2: '/dashboard/campaign/v2/save-details',
  getCampaignLeadsInfoWithProfileV2: '/dashboard/campaign/v2/leads',
  duplicateCampaignV2: '/dashboard/campaign/v2/duplicate-campaign',
  deleteLeadFromCampaignV2: '/dashboard/campaign/v2/delete-lead',
  getEmailsAttachedToCampaignV2: '/dashboard/campaign/v2/connected-emails',
  launchCampaignV2: '/dashboard/campaign/v2/launch',
  saveCampaignLeadV2: '/dashboard/v2/campaign/add-influencers',
  getIntelligentNamesV2: '/dashboard/campaign/v2/get-intelligent-names',
  updateIntelligentNamingV2: '/dashboard/campaign/v2/update-intelligent-naming',
  getListWiseCampaignStats: '/dashboard/campaign/v2/list-filter-campaign-stats',
  searchListsForCampaign: '/dashboard/v2/campaign/search-lists',
  searchInfluencersForCampaign: '/dashboard/v2/campaign/search-influencers',
  updateCampaignData: '/dashboard/v2/campaign/update-campaign-data',

  // templates
  listAllTemplates: '/dashboard/campaign/template/list',
  createEmailTemplate: '/dashboard/campaign/template/create',
  sendEmailInbox: '/dashboard/inbox/send-email',

  // single email
  sendEmail: '/dashboard/profile/send-email',
  getEmailThreads: '/dashboard/profile/threads',
  //relationship-history
  getAllHistoryForProfile: '/dashboard/relationship-history',
  // addRelationshipHistory: '/dashboard/relationship-history/add',
  // affiliate
  getInfluencerAffiliateDetails: '/dashboard/v2/affiliate',
  createAffiliate: '/dashboard/v2/affiliate/create',
  createCoupon: '/dashboard/v2/affiliate/coupon/create',
  updateCouponCode: '/dashboard/v2/affiliate/coupon/update',
  deleteCouponCode: '/dashboard/v2/affiliate/coupon/delete',
  createBulkAffiliate: '/dashboard/v2/affiliate/bulk/create',
  bulkMoveToSathiCampaign: '/dashboard/v2/affiliate/bulk/move-campaign',
  updateBulkAffiliateCommission: '/dashboard/v2/affiliate/bulk/commission/update',
  createBulkCoupon: '/dashboard/v2/affiliate/bulk/coupon',
  updateBulkCoupon: '/dashboard/v2/affiliate/bulk/coupon/update',
  getTotalSalesGrowthStats: '/dashboard/v2/affiliate/growth/stats',
  updateRefCode: '/dashboard/v2/affiliate/refcode/update',
  // discount code templates
  getDiscountTemplates: '/dashboard/v2/discount-templates/',
  createDiscountTemplate: '/dashboard/v2/discount-templates/',
  updateDiscountTemplate: '/dashboard/v2/discount-templates/',
  deleteDiscountTemplate: '/dashboard/v2/discount-templates/delete',
  makeDiscountTemplatePrimary: '/dashboard/v2/discount-templates/make-primary',

  // Multi user access
  getTeamMembers: '/dashboard/team-member',
  createNewTeamMember: '/dashboard/team-member',
  updateTeamMember: '/dashboard/team-member',
  teamSignIn: '/dashboard/team-member/accept-invite',
  resendTeam: '/dashboard/team-member/resend-invite',

  // Inbound Email Templates
  getInboundEmailTemplates: '/dashboard/inbound-email-templates/',
  createInboundEmailTemplate: '/dashboard/inbound-email-templates/',
  updateInboundEmailTemplate: '/dashboard/inbound-email-templates/',
  updateInboundEmailTemplateOrder: '/dashboard/inbound-email-templates/update-order/',
  deleteInboundEmailTemplate: '/dashboard/inbound-email-templates/delete',
  getPrimaryEmailByType: '/dashboard/inbound-email-templates/get-primary-email-by-type',

  // Usage Rights Templates
  getUsageRightsTemplates: '/dashboard/v2/post-tracking/usage-rights-templates',
  createUsageRightsTemplate: '/dashboard/v2/post-tracking/usage-rights-templates',
  updateUsageRightsTemplate: '/dashboard/v2/post-tracking/usage-rights-templates',
  deleteUsageRightsTemplate: '/dashboard/v2/post-tracking/usage-rights-templates',
  updateSystemUsageRightsTemplate: '/dashboard/v2/post-tracking/usage-rights-templates/system',

  // referral links
  createAffiliateLink: '/dashboard/v2/affiliate/referral/link/create',
  updateAffiliateLink: '/dashboard/v2/affiliate/referral/link/update',
  deleteAffiliateLink: '/dashboard/v2/affiliate/referral/link/delete',
  // integrations
  getAllConnectedAppDetails: '/dashboard/integration/list',
  getGoAppProDetails: '/dashboard/integration/goaffpro/details',
  connectGoAffProApp: '/dashboard/integration/goaffpro',
  connectVeeper: '/dashboard/v2/integration/connect-veeper',
  connectCreatorCommerce: '/dashboard/v2/integration/connect-creator-commerce',
  connectSathi: '/dashboard/v2/integration/connect-sathi',
  migrateGAPToSathi: '/dashboard/v2/integration/sathi/migrate-data',
  getSathiMigrationStatus: '/dashboard/v2/integration/sathi/migration-status',
  updateGOAffProDetails: '/dashboard/integration/goaffpro/update',
  connectPaypalToGoAffPro: '/dashboard/integration/paypal',
  connectStandalonePaypal: '/paypal/connect',
  getStandalonePaypalConnectionStatus: '/paypal/connection-status',
  disconnectStandalonePaypal: '/paypal/disconnect',
  getPayPalPayoutDetails: '/dashboard/integration/paypal/details',
  updatePayPalPayoutDetails: '/dashboard/integration/paypal/update',
  connectKlaviyo: '/dashboard/integration/klaviyo',
  getKlaviyoDetails: '/dashboard/integration/klaviyo',
  getSlackDetails: '/dashboard/integration/slack',
  getSendlaneDetails: '/dashboard/integration/sendlane',
  connectSendlane: '/dashboard/integration/sendlane',
  getFacebookAuthURL: '/facebook/auth-url',
  getFacebookIntegrationStatus: '/facebook/integration-status',
  updateSyncStages: '/dashboard/v2/integration/update-sync-stages',
  // affiliate payments
  getAllPendingPayments: '/dashboard/affiliate-payments/get-all-pending-payments',
  getAllCompletedPayments: '/dashboard/v2/affiliate-payments/get-all-completed-payments',
  payInfluencers: '/dashboard/affiliate-payments/pay-influencers',
  getSelectedInfluencerCompletedPayments: '/dashboard/affiliate-payments/get-selected-influencer-completed-payments',
  getSelectedInfluencerDetailedPendingPayment: '/dashboard/v2/affiliate-payments/get-affiliate-orders',
  logIndividualpayment: '/dashboard/affiliate-payments/log-individual-payment',
  startPaypalPayout: '/dashboard/affiliate-payments/start-paypal-payout',
  completePaypalPayout: '/dashboard/affiliate-payments/complete-paypal-payout',
  getAffilateData: '/dashboard/affiliate-payments/get-affiliate-data',
  exportPaypalCsv: '/dashboard/affiliate-payments/export-paypal-csv',
  undoPayment: '/dashboard/affiliate-payments/undo-transaction',
  oneOffPayment: '/dashboard/affiliate-payments/one-off-payment',
  // survey
  getSurveyData: '/dashboard/survey',
  addSurveyData: '/dashboard/survey',
  personalizedOnboarding: '/dashboard/survey/personalised-onboarding',
  // addresses
  addAddress: '/dashboard/profile/address/add',
  updateAddress: '/dashboard/profile/address/update',
  resolveShippingName: '/dashboard/v2/profile/shipping-name',
  // shipping
  getProducts: '/dashboard/v2/store/products',
  getProductsList: '/dashboard/store/product/list',
  getOrderList: '/dashboard/profile/orders',
  createMultiProductOrder: '/dashboard/v2/store/m/order/create',
  pushBulkOrderToQueue: '/dashboard/v2/store/m/orders/queue',
  resendProducts: '/dashboard/store/order/resendProduct',
  getFrequentlyShippedProducts: '/dashboard/v2/store/frequently-shipped-products',
  // utils
  getLocationDetails: '/dashboard/location-details',
  // inbound
  getInboundDetails: '/dashboard/inbound/',
  createDomainForInbound: '/dashboard/inbound/create',
  getInboundSetupDetails: '/dashboard/inbound/setup/details',
  saveInboundStepDetails: '/dashboard/inbound/setup/step',
  getInboundApplicationList: '/dashboard/inbound/applications',
  updateApprovalStatus: '/dashboard/inbound/update-status',
  getCreatorApplicationDetails: '/dashboard/inbound/creator-application-details',
  updateSubdomain: '/dashboard/inbound/update-subdomain',
  updateRecentFonts: '/dashboard/v2/inbound/update-recent-fonts',
  checkIfProfileExistsV2: '/dashboard/v2/inbound/check-if-profile-exists',
  generateBulkDiscountCodeV2: '/dashboard/v2/inbound/approve-and-create-codes',
  approveBulkApplicationsV2: '/dashboard/v2/inbound/approve-applications',
  createSubdomainForUser: '/dashboard/v2/inbound/add-subdomain',
  rejectBulkApplications: '/dashboard/inbound/reject-inbound-profiles',
  sendBulkEmails: '/dashboard/inbound/send-emails',

  getAvailablePlatforms: '/dashboard/v2/inbound/get-available-platforms',

  // resources
  getResourceList: '/dashboard/inbound/resources',
  createResource: '/dashboard/inbound/resource/create',
  deleteResource: '/dashboard/inbound/resource/delete',
  // widget
  createWidget: '/dashboard/inbound/widget/create',

  //multiple applications routes:
  getInboundApplicationListV2: '/dashboard/v2/inbound/applications',
  createInboundApplicationForm: '/dashboard/v2/inbound-form',
  getAllInboundApplicationForms: '/dashboard/v2/inbound-form',
  deleteInboundApplicationForm: '/dashboard/v2/inbound-form',
  updateInboundApplicationForm: '/dashboard/v2/inbound-form',
  getConversionRatesForForms: '/dashboard/v2/inbound-form/get-conversion-rates',
  saveInboundStepDetailsV2: '/dashboard/v2/inbound/setup/step',

  // log post
  createLogPost: '/dashboard/logPost/create',
  createLogStory: '/dashboard/logPost/create-story',
  getAllLogPosts: '/dashboard/logPost/getAll',
  deleteLogPost: '/dashboard/logPost/delete',
  getLinkPreviewData: '/dashboard/logPost/link-preview-data',
  refreshLogPostData: '/dashboard/logPost/refresh-log-posts',
  // performance
  getPerformanceStats: '/dashboard/v2/performance/stats',
  getProductFunnel: '/dashboard/v2/performance/product-funnel',
  getTopAffiliates: '/dashboard/v2/performance/top-affiliates',
  getPerformanceTrendChartData: '/dashboard/v2/performance/chart-data',
  exportPerformanceData: '/dashboard/v2/performance/export-performance-data',
  exportDatewiseOrdersData: '/dashboard/v2/performance/export-orders-data',

  // handwrytten api routes
  updateUserAddress: '/dashboard/user/update-address',
  refuseGift: '/dashboard/user/refuse-gift',

  // activation emails
  getAllActivationCampaigns: '/dashboard/activation-campaigns/all',
  switchCampaignStatus: '/dashboard/activation-campaigns/switch-status',
  getAllConditions: '/dashboard/activation-campaigns/all-conditions',
  createActivationCampaign: '/dashboard/v2/activation-campaign/create-campaign',
  updateIndividualCampaign: '/dashboard/v2/activation-campaign/update-campaign',
  excludedLists: '/dashboard/activation-campaigns/exclusions',
  getActivationCampaignsForProfile: '/dashboard/activation-campaigns',
  deleteActivationCampaign: '/dashboard/v2/activation-campaign/delete',

  // Klaviyo
  syncOldDataToKlaviyo: '/dashboard/v2/klaviyo/sync-data',

  // Sendlane
  syncOldDataToSendlane: '/dashboard/sendlane/sync-data',
  // conditional Ratnas
  getAllConditionalRatnasVideos: '/dashboard/conditional-ratnas/videos',
  updateVideoWatched: '/dashboard/conditional-ratnas/update-video-watch',
  updateVideoCheckList: '/dashboard/conditional-ratnas/update-video-checklist',

  // woke cancellation
  getAttachedPaymentMethods: '/dashboard/payment/methods',
  getUserStatisticsForCancellation: '/dashboard/payment/statistics',
  getCancellationQuestions: '/dashboard/cancellation-survey/questions',
  saveCancellationSurvey: '/dashboard/cancellation-survey/save',
  cancelSubscription: '/dashboard/payment/cancel-subscription',
  pauseSubscription: '/dashboard/payment/pause-subscription',
  extendTrial: '/dashboard/payment/extend-trial',
  createDiscountedSubscription: '/dashboard/payment/update-discounted-subscription',

  updateSubscriptionQuarterly: '/dashboard/payment/update-subscription-for-quarterly-plan',
  updateSubscriptionMonthly: '/dashboard/payment/update-subscription-for-monthly-plan',

  getBillingInfoForUser: '/dashboard/user/get-billing-info',
  updateBillingInfoForUser: '/dashboard/user/update-billing-info',
  detachPaymentMethod: '/dashboard/payment/methods/detach',
  switchToAnnualPlan: '/dashboard/payment/switch-annual-plan',
  updateSubscriptionForAnnualPlan: '/dashboard/payment/update-subscription-for-annual-plan',
  updateSubscriptionForQuarterlyPlan: '/dashboard/payment/update-subscription-for-quarterly-plan',
  changeDefaultCard: '/dashboard/payment/change-default-card',
  updatePaymentMethod: '/dashboard/payment/methods',
  revertCancellationInStripe: '/dashboard/payment/revert-cancellation',
  getSubscriptionInfo: '/dashboard/payment/get-subscription-info',
  removePauseFromSubscription: '/dashboard/payment/remove-pause-from-subscription',
  getPendingInvoice: '/dashboard/cancellation-survey/get-pending-invoice',
  payPendingInvoice: '/dashboard/cancellation-survey/pay-pending-invoice',
  startCancelationJourney: '/dashboard/cancellation-survey/start-journey',
  updateCancelationJourney: '/dashboard/cancellation-survey/update-journey',

  // Profile routes
  getIntelligentName: '/dashboard/profile/get-intelligent-name',
  bulkDeleteProfiles: '/dashboard/profile/bulk-delete-profiles',
  deleteProfileFromList: '/dashboard/profile/delete-from-list',

  // user details
  getUserSettings: '/dashboard/user/settings',
  enableAutoArchive: '/dashboard/user/settings/auto-archive-status-count',
  switchOnAutoArchive: '/dashboard/user/settings/switch-on-auto-archive',
  switchOffAutoArchive: '/dashboard/user/settings/switch-off-auto-archive',
  updateUserSettings: '/dashboard/user/settings/update',
  updateStrategySessionStatus: '/dashboard/user/update-strategy-session-status',
  createCustomTag: '/dashboard/user/settings/create-tag',
  removeCustomTag: '/dashboard/user/settings/remove-tag',
  bookStrategySession: '/dashboard/user/book-strategy-session',

  // commission tier
  getCommissionTiers: '/dashboard/commission-tier',
  createCommissionTier: '/dashboard/v2/commission-tier/create',
  updateCommissionTier: '/dashboard/v2/commission-tier/update',
  makeCommissionTierPrimary: '/dashboard/commission-tier/make-primary',
  deleteCommissionTier: '/dashboard/commission-tier/delete',
  updateGlobalCommissionTier: '/dashboard/commission-tier/toggle-global-commission-tier',

  // creator dashboard
  getCreatorDetails: '/inbound/admin/creator/details',
  // changelog
  getChangeLogs: '/dashboard/changelog/list',
  updateLastViewedVersion: '/dashboard/v2/changelog/update-last-viewed-version',

  // Cost Of Goods
  getCostOfGoods: '/dashboard/v2/cost-of-goods/',
  addCostOfGoods: '/dashboard/v2/cost-of-goods/',
  editCostOfGoods: '/dashboard/v2/cost-of-goods/',
  deleteCostOfGoods: '/dashboard/v2/cost-of-goods/delete',
  checkExistingCostOfGoods: '/dashboard/v2/cost-of-goods/check-existing-cogs',

  // blacklist influencers
  blockInfluencers: '/dashboard/blacklist-influencers/block',
  updateBlacklistDuration: '/dashboard/blacklist-influencers/update-duration',
  getBlacklistedInfluencers: '/dashboard/blacklist-influencers',
  unblockInfluencers: '/dashboard/blacklist-influencers/unblock',
  autoUnblock: '/dashboard/blacklist-influencers/auto-unblock',

  // post tracking
  searchPostTrackingInfluencers: '/dashboard/post-tracking/search-influencer',
  createPostTrackingCampaign: '/dashboard/v2/post-tracking/create',
  getPostTrackingCampaign: '/dashboard/post-tracking/get-all-campaigns',
  getPostTrackingCampaignById: '/dashboard/post-tracking/get-campaign-details',
  getPostTrackingCampaignStats: '/dashboard/post-tracking/stats',
  getPostTrackingRevenue: '/dashboard/post-tracking/revenue-stats',
  getPostTrackingCampaignPosts: '/dashboard/post-tracking/get-campaign-posts',
  updatePostTrackingStatus: '/dashboard/post-tracking/update-status',
  getCampaignDownloadLinks: '/dashboard/post-tracking/get-download-links',
  getTrackedImpactChartData: '/dashboard/v2/post-tracking/analytics/tracked-impact',

  // new pulse routes
  createPulseCampaign: '/pulse/campaigns',

  // challenges
  challenges: '/dashboard/v2/challenges',

  // edit campaign
  editPostTrackingCampaign: '/dashboard/post-tracking/update',
  getPrefilledCampaignDetails: '/dashboard/post-tracking/prefill-details',

  // post tracking advanced analytics
  getKeyPerformanceIndicators: '/dashboard/v2/post-tracking/stats/key-performance-indicators',
  getTotalViewsAcrossPlatforms: '/dashboard/v2/post-tracking/stats/total-views-across-platforms',
  getTopPerformingCreators: '/dashboard/v2/post-tracking/stats/top-performing-creators',
  getTopPerformingPosts: '/dashboard/v2/post-tracking/stats/top-performing-posts',
  getImpressionsAcrossPlatforms: '/dashboard/v2/post-tracking/stats/impressions-across-platforms',
  getContentCountStats: '/dashboard/v2/post-tracking/stats/content-count-stats',
  getEngagementBreakdownStats: '/dashboard/v2/post-tracking/stats/engagement-breakdown',

  // stages
  stages: '/dashboard/stages',
  getAllStageTriggers: '/dashboard/stages/user-automations/triggers',
  updateStageTrigger: '/dashboard/stages/user-automations',

  // Usage rights
  sendUsageRequest: '/dashboard/post-tracking/send-usage-request',
  getAllUsageRequests: '/dashboard/post-tracking/get-usage-rights',
  remindUsageRequest: '/dashboard/post-tracking/remind-request',
  acceptUsageRequest: '/dashboard/post-tracking/accept-usage-request-changes',

  getPostTrackingInfluencerDetails: '/dashboard/v2/post-tracking/get-influencer-details',

  // Post Tracking Labels
  getPostTrackingLabels: '/dashboard/post-tracking/get-all-labels',
  createPostTrackingLabel: '/dashboard/post-tracking/create-label',
  editPostTrackingLabel: '/dashboard/post-tracking/edit-label',

  attachLabel: '/dashboard/post-tracking/attach-label',
  detachLabel: '/dashboard/post-tracking/detach-label',
  deleteLabel: '/dashboard/post-tracking/delete-label',
  getLibraries: '/dashboard/post-tracking/all-libraries',
  createLibrary: '/dashboard/post-tracking/create-library',
  editLibrarySettings: '/dashboard/post-tracking/edit-library',

  // Inbox Apis
  inboxListEmails: '/dashboard/inbox/all-email',
  modifyEmail: '/dashboard/inbox/modify-email',

  starEmails: '/dashboard/inbox/star',
  unstarEmails: '/dashboard/inbox/emails/actions/unstar',
  readEmail: '/dashboard/inbox/read',
  archiveEmails: '/dashboard/inbox/archive',
  unArchiveEmails: '/dashboard/inbox/emails/actions/unarchive',
  moveToBin: '/dashboard/inbox/emails/actions/bin',
  emailThreads: '/dashboard/inbox/email',
  searchEmail: '/dashboard/inbox/profiles/search',
  searchInfluencerForSendingEmail: '/dashboard/inbox/user-profiles',
  deleteEmails: '/dashboard/inbox/bin',
  emptyBin: '/dashboard/inbox/emails/actions/emptyBin',
  getThreadsForProfile: '/dashboard/inbox/threads/profile',
  hideInfluencerEmails: '/dashboard/inbox/profile/hide',
  getEmailsForIIV: '/dashboard/inbox/email-iiv',
  getAllSnippets: '/dashboard/v2/inbox-snippet',
  createInboxSnippet: '/dashboard/v2/inbox-snippet',
  updateInboxSnippet: '/dashboard/v2/inbox-snippet',
  deleteInboxSnippet: '/dashboard/v2/inbox-snippet',
  getUnreadEmailsCount: '/dashboard/inbox/unread-count',
  dismissFollowup: '/dashboard/inbox/dismiss-follow-up',
  getFollowupEmails: '/dashboard/inbox/follow-up-reminder-emails',
  inboxTour: '/dashboard/tours/inbox',

  // contracts
  contractsCreate: '/dashboard/contracts/create',
  contractsList: '/dashboard/contracts/list',
  sendContract: '/dashboard/contracts/send',
  getDataToFinalizeContract: '/dashboard/contracts/finalize',
  finalizeContract: '/dashboard/contracts/finalize/signed',

  // custom contracts
  getAllFieldsForContract: '/dashboard/v2/contracts/template/fields/getAll',
  createContractTemplate: '/dashboard/v2/contracts/template',
  customContractList: '/dashboard/v2/contracts/template/getAll',
  getContractTemplate: '/dashboard/v2/contracts/template',
  updateCustomContract: '/dashboard/v2/contracts/template',
  deleteCustomContract: '/dashboard/v2/contracts/template',

  // signatures
  signaturesImageCreate: '/dashboard/signatures/image/create',
  signaturesImageList: '/dashboard/signatures/image/list',
  signaturesTextCreate: '/dashboard/signatures/text/create',
  signaturesTextList: '/dashboard/signatures/text/list',

  // Disconnected emails
  remindLatedEmailDisconnected: '/dashboard/v2/notifications/email-disconnect/remind-later',
  markAsEmailDisconnectedSeen: '/dashboard/v2/notifications/email-disconnect/mark-as-seen',

  //relationship-board

  checkForDuplicateProfiles: '/dashboard/relationship-board/duplicate-profile-check',
  addCreatorFromRelationship: '/dashboard/relationship-board/add-profile',
  bulkActionsForRelationshipBoard: '/dashboard/relationship-board/bulk-actions',
  getInfluencersList: '/dashboard/relationship-board/get-influencer-list',
  filterRelationshipV2: '/dashboard/relationship-board/filter',
  addNonSocialCreator: '/dashboard/v2/profile/add/non-social-creator',
  checkIfNonSocialInfluencerExists: '/dashboard/v2/profile/check-if-influencer-exists',
  getInfluencersForListView: '/dashboard/relationship-board/get-table-view-data',
  updateTeamMemberData: '/dashboard/v2/team-member',

  //GA route
  updateGoogleAnalyticsEventStatus: '/dashboard/v2/user/update-google-analytics-status',

  //Automated Shipments
  getCurrentAutomatedShipmentsForInfluencer: '/dashboard/v2/automated-shipment',
  createAutomatedShipment: '/dashboard/v2/automated-shipment',
  updateAutomatedShipment: '/dashboard/v2/automated-shipment',

  //Bulk Actions UM
  checkInfluencersForActivePartnerships: '/dashboard/v2/subscription/check-influencers-active-partnership',

  //edit commission owed
  adjustCommission: '/dashboard/v2/affiliate-payments/adjust-commission',
  generateInvoice: '/dashboard/v2/affiliate-payments/payments/history/generate-invoice',

  //Multi Brand Login
  getAllConnectedBrands: '/dashboard/v2/connected-brands',
  addNewConnectedBrand: '/dashboard/v2/connected-brands/create',
  switchBrandAccount: '/dashboard/v2/connected-brands/switch',
  removeConnectedBrand: '/dashboard/v2/connected-brands/delete',

  //Custom Discount Codes
  generateCodesAndEvaluate: '/dashboard/v2/inbound/evaluate-autogenerated-codes',
  checkIfCouponExistsAlready: '/dashboard/v2/inbound/check-if-coupon-exists',

  // Content Submissions
  contentSubmissions: '/dashboard/v2/content-submission',

  //automated payments
  getCurrentAutomatedPaymentsForInfluencer: '/dashboard/v2/automated-payment',
  createAutomatedPayment: '/dashboard/v2/automated-payment/create',
  updateAutomatedPayment: '/dashboard/v2/automated-payment/update',
  retryAutomatedPayment: '/dashboard/v2/automated-payment/retry-failed-payment',

  dismissEnrichmentStatusForProfile: '/dashboard/v2/profile/dismiss-enrichment-status',
  getEnrichmentDataForList: '/dashboard/v2/list/enrichment-data',
  dismissEnrichmentSummaryModal: '/dashboard/v2/list/dismiss-enrichment-modal',

  // Onboarding Videos
  getAllOnboardingVideos: '/dashboard/v2/onboarding-videos',
  updateOnboardingStepProgress: '/dashboard/v2/onboarding-videos/steps/progress',

  // Revenue Generated
  getRevenueGeneratedByInfluencer: '/dashboard/v2/profile/revenue-generated-chart-data',

  // search influencers
  searchInfluencers: '/dashboard/v2/profile/search-influencers',

  // sia
  personalizeSia: '/dashboard/v2/sia/personalize',
  generateEmailsBySia: '/dashboard/v2/sia/generate-emails',
  getPersonalizationStatus: '/dashboard/v2/sia/personalization-status',
  uploadPersonalizationGuidelines: '/dashboard/v2/sia/upload-documents',
  deletePersonalizationGuidelines: '/dashboard/v2/sia/delete-documents',
  generateFollowupEmails: '/dashboard/v2/sia/generate-follow-up-emails',
  updateFollowupContent: '/dashboard/v2/sia/update-follow-up-email',
  sendFollowupEmails: '/dashboard/v2/sia/send-follow-up-emails',
  getDraftedFollowupEmails: '/dashboard/v2/sia/get-follow-up-emails',

  // personal lines
  getPersonalLines: '/dashboard/v2/sia/personal-lines/retrieve',
  generatePersonalLines: '/dashboard/v2/sia/personal-lines',
  savePersonalLinesForProfile: '/dashboard/v2/sia/personal-lines',

  checkIfCustomCouponExists: '/dashboard/v2/affiliate/coupon/custom/check',
  getSathiAffiliateStatus: '/dashboard/v2/affiliate/duplicate/status',

  linkSaralAffiliateToSathi: '/dashboard/v2/affiliate/duplicate/link',
  getAllSathiCampaigns: '/dashboard/v2/sathi/campaigns/all',
  moveSathiAffiliateCampaign: '/dashboard/v2/sathi/affiliates',
  getSathiMagicLink: '/dashboard/v2/affiliate/sathi',

  //product request
  productRequestSettings: '/dashboard/v2/product-request-settings/',
  productRequests: '/dashboard/v2/product-requests/',
  approveProductRequest: '/dashboard/v2/product-requests',
  rejectProductRequest: '/dashboard/v2/product-requests',

  //list campaigns
  enableListCampaign: listCampaignRoutes.listCampaignsBaseRoute + '/enable',
  getListCampaigns: listCampaignRoutes.listCampaignsBaseRoute,
  createListCampaign: listCampaignRoutes.listCampaignsBaseRoute,
  updateListCampaign: listCampaignRoutes.listCampaignsBaseRoute,
  reorderListCampaignStages: listCampaignRoutes.listCampaignStagesBaseRoute + '/reorder',
  updateListCampaignStageForInfluencer:
    listCampaignRoutes.listCampaignStagesBaseRoute + '/update-stage-for-influencers',
  getAllListCampaignStages: listCampaignRoutes.listCampaignStagesBaseRoute,
  createListCampaignStage: listCampaignRoutes.listCampaignStagesBaseRoute,
  updateListCampaignStage: listCampaignRoutes.listCampaignStagesBaseRoute,
  deleteListCampaignStage: listCampaignRoutes.listCampaignStagesBaseRoute + '/delete',
  updateListCampaignInfluencer: listCampaignRoutes.listCampaignInfluencersBaseRoute,
  addInfluencersToListCampaign: listCampaignRoutes.listCampaignsBaseRoute + '/add-influencers',
  removeInfluencersFromListCampaign: listCampaignRoutes.listCampaignsBaseRoute + '/remove-influencers',
  getListCampaignAnalyticsStats: listCampaignRoutes.listCampaignAnalyticsBaseRoute + '/stats',
  getListCampaignAnalyticsFunnel: listCampaignRoutes.listCampaignAnalyticsBaseRoute + '/stages-funnel-data',
  getListCampaignTopPerformingCreators: listCampaignRoutes.listCampaignAnalyticsBaseRoute + '/top-performers',

  getListCampaignPosts: listCampaignRoutes.listCampaignTrackingBaseRoute + '/posts',
  logPostForListCampaign: listCampaignRoutes.listCampaignTrackingBaseRoute + '/log-post',

  searchListCampaignInfluencers: listCampaignRoutes.listCampaignInfluencersBaseRoute + '/search',
  getAllListCampaignInfluencers: listCampaignRoutes.listCampaignInfluencersBaseRoute,
  getListCampaignsForInfluencers: listCampaignRoutes.listCampaignInfluencersBaseRoute + '/list-campaigns',

  getRatnaTriggerAlerts: ratnaTriggerBaseRoute + '/get-ratna-usage-alerts',
  dismissRatnaAlert: ratnaTriggerBaseRoute + '/dismiss-ratna-alert',
};

const server_url = import.meta.env.REACT_APP_LOCAL_SERVER_URL;
const apiv2_server_url = import.meta.env.REACT_APP_API_V2_SERVER_URL;

export { Api_routes, server_url, apiv2_server_url };
